import { Space } from '@/components/base';
import { Tooltip } from '@/shared/ui';

type Props = {
  title: string;
  date: string;
};
export function ReportPublicDocumentHeader({ title, date }: Props) {
  const onLogoClick = () => {
    window.open(window.location.origin, '_blank');
  };

  return (
    <div className="px-10 py-8 border-b bg-background/95 backdrop-blur">
      <div className="flex items-center">
        <div onClick={onLogoClick} style={{ cursor: 'pointer' }} role="button">
          <img src="/assets/logo-syncly.svg" style={{ height: 28 }} />
        </div>
        <Space w={12} />
        <Tooltip content={title}>
          <h1 className="text-2xl font-semibold tracking-tight truncate text-foreground max-w-200">
            {title}
          </h1>
        </Tooltip>
        <Space w={16} />
        <p className="text-sm font-medium text-muted-foreground">{date}</p>
      </div>
    </div>
  );
}
